// Map API endpoints here

export default $axios => ({
  getInitialData() {
    return $axios.get('/api/data');
  }
});
